import { BiError } from 'react-icons/bi';
import { Button, Text, VStack } from 'ui_2';

export const ErrorMessage = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <VStack className='flex min-h-[100dvh] items-center justify-center bg-gray-50'>
      <VStack className='max-w-[80%] items-center gap-2 rounded-[10px] p-4 text-center'>
        <BiError className='text-red-600' size={32} />
        <Text color='red'>There was an error loading your game</Text>
        <Text color='red'>{errorMessage}</Text>
        <Button
          variant='gray'
          className='w-4/5'
          onClick={() => window.location.reload()}
        >
          Try again
        </Button>
      </VStack>
    </VStack>
  );
};
